import type {
  ForwardRefExoticComponent,
  HTMLAttributes,
  RefAttributes
} from 'react'
import styled, { type DataAttributes } from 'styled-components'

export type PageContentWrapperProps = {
  /** Vertical gap between direct children, in px. */
  $gap?: number
  /** Top padding, in px. */
  $paddingTop?: number
  /** Horizontal padding, in px. */
  $paddingX?: number
  /** Bottom padding, in px. */
  $paddingBottom?: number
}

/**
 * Centred page-content column (max-width 1080px) — the canonical wrapper for
 * top-level screens. Extend with styled(PageContentWrapper) for screen-specific
 * responsive rules.
 */
const PageContentWrapper = styled.div<PageContentWrapperProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap = 24 }) => $gap}px;
  max-width: 1080px;
  margin: 0 auto;
  padding: ${({ $paddingTop = 0, $paddingX = 0, $paddingBottom = 48 }) =>
    `${$paddingTop}px ${$paddingX}px ${$paddingBottom}px`};
` as ForwardRefExoticComponent<
  HTMLAttributes<HTMLDivElement> &
    DataAttributes &
    PageContentWrapperProps &
    RefAttributes<HTMLElement>
>

export default PageContentWrapper
